module.exports = "fragment LabeledPrice on LabeledPrice {\n  label\n  asString\n  currency\n  amount\n}\n"